import { render, staticRenderFns } from "./move-current-mtp-warning-modal.vue?vue&type=template&id=1184b952"
import script from "./move-current-mtp-warning-modal.ts?vue&type=script&lang=ts&external"
export * from "./move-current-mtp-warning-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./move-current-mtp-warning-modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1184b952')) {
      api.createRecord('1184b952', component.options)
    } else {
      api.reload('1184b952', component.options)
    }
    module.hot.accept("./move-current-mtp-warning-modal.vue?vue&type=template&id=1184b952", function () {
      api.rerender('1184b952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-input/move-current-mtp-warning-modal/move-current-mtp-warning-modal.vue"
export default component.exports